import React from "react";
import { t } from "ttag";

import { UGCListSubBlock, UGCPost } from "../models/ugc";
import { UGCGrid } from "./UGCGrid";

interface IProps {
    pageSize: number;
    random?: boolean;
}

export const UGCApiGrid = ({
    pageSize,
    random = false,
}: IProps): React.ReactNode => {
    const [posts, setPosts] = React.useState<UGCListSubBlock[]>([]);
    const [limit, setLimit] = React.useState<number | undefined>(undefined);
    const pageRef = React.useRef<number>(0);

    const getNextPage = async (): Promise<void> => {
        let url = `/api/cms/v2/social/?limit=${pageSize}`;
        if (random) {
            url += "&order=random";
        } else {
            url += `&offset=${pageSize * pageRef.current}`;
        }
        const response = (await fetch(url).then((r) => r.json())) as Response;
        const items = response.items.map((post) => ({
            post: post,
        }));
        const totalCount = response.meta.total_count;
        setPosts((prevPosts) => [...prevPosts, ...items]);
        pageRef.current = pageRef.current + 1;
        setLimit(totalCount);
    };

    React.useEffect(() => {
        void getNextPage();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            <UGCGrid tiles={posts} />
            {!random && limit && posts.length < limit ? (
                <button
                    className="button button--full-width button--alabaster load-more-posts"
                    onClick={getNextPage}
                >
                    {t`Load More Posts`}
                </button>
            ) : null}
        </>
    );
};

interface Response {
    meta: {
        total_count: number;
    };
    items: UGCPost[];
}
